<template>
    <div class="recommendPage">
        <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
            <img src="@/assets/dzp/swice.png" />
        </swiper-slide>
        </swiper>
        <van-form ref='form'>
            <div class="shrxx">姓名(需满16周岁) </div>
            <van-cell-group>
                <van-field required  v-model="dataFrom.takeNickname" error-message :rules="[ { required: true, message: '请输入您的真实姓名' },{ pattern: /[\u4e00-\u9fa5]{2}/, message: '不能为数字、字母、特殊符号且不少于2个汉字！'}]" clearable class="name" placeholder="请输入您的真实姓名" />
            </van-cell-group>
            <div class="shrxx">手机号码(已加密) </div>
            <van-cell-group>
                <van-field required v-model="dataFrom.takePhone" maxlength="11" :rules="[ { required: true, message: '请填写您的联系电话！' },  { pattern: /^1[3456789]\d{9}$/, message: '联系电话格式错误！'} ]" clearable placeholder="请填写您的联系电话" />
            </van-cell-group>
            <div class="shrxx">验证码</div>
            <van-cell-group>
                <van-row>
                    <van-col :span="16">
                        <van-field v-model="smsCode" clearable maxlength="8" required placeholder="请输入验证码"  :rules="[ { required: true, message: '请输入验证码！' }]"/>
                    </van-col>
                    <van-col :span="8">
                    <van-button  type="primary" size="small"  :disabled="smsFlag" class="codeBtn" @click="getSmsCode">{{btnTxt}}</van-button>
                    </van-col>
                </van-row>
            </van-cell-group>
            <div class="shrxx">收货地址</div>
            <van-cell-group>
                <van-field required v-model="dataFrom.pcaAddress" :rules="[ { required: true, message: '请选择收货地址！' }]"  clearable placeholder="请选择省市区" @focus="showAddressVisible()"/>
            </van-cell-group>
            <div class="shrxx">详细地址</div>
            <van-cell-group>
                <van-field required v-model="dataFrom.takeAddress"  :rules="[ { required: true, message: '请填写您的详细地址！' }]" clearable placeholder="街道/小区/门牌号等" />
            </van-cell-group>
        </van-form>
        <van-popup v-model="dataFrom.addressVisible" position="bottom">
            <van-area
                :area-list="areaList"
                :columns-placeholder="['请选择', '请选择', '请选择']"
                @cancel="cancelSelectAddress()"
                @confirm="selectAddress"
            />
        </van-popup>
        <div style="text-align:center;">
            <van-button round type="info" class="btnButton" @click="sunmbitFn()">领取</van-button>
        </div>
    </div>
</template>

<script>
import areaListData from "@/utils/Area.js";
import { wxRequest } from '@/api/user'
import { Toast,Dialog} from 'vant';
export default {
    data() {
        return {
            dataFrom:{
                takeNickname:'' ,
                addressVisible:false,
                takePhone:'',
                takeAddress:'',
                changeCmccSim:2,
                pcaAddress:'',
                agentId:'',
                smsCode:'',
            },
            smsCode: '',
            btnTxt: '获取验证码',
            checked:false,
            time: 3 * 60 * 60 * 1000,
            areaList:areaListData,
            swiperOption: {
                loop: true,
                effect: "coverflow",
                grabCursor: true,
                centeredSlides: true, // 设置为true时,带有active-slide类名的图片会居中
                slidesPerView: 1.2,
                // initialSlide: 1,
                // autoplay:false,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                slideToClickedSlide: true,
                coverflowEffect: {
                    rotate: 0, // 旋转的角度
                    stretch: 200, // 拉伸   图片间左右的间距和密集度
                    depth: 80, // 深度   切换图片间上下的间距和密集度
                    modifier: 3, // 修正值 该值越大前面的效果越明显
                    slideShadows: false, // 页面阴影效果
                },
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
            }
        };
    },
    computed: {
        smsFlag(){
            if(this.dataFrom.takePhone.length == 11 && this.btnTxt == '获取验证码'){
                return false;
            }else{
                return true;
            }
        },

    },
    mounted() {
    },
    methods:{
        getSmsCode(){
            const rulut = this.$getRsaCode(this.dataFrom.takePhone) //加密
            var data = {
                userPhone: rulut
            }
            wxRequest("bindPhone/sms/code/auth", data, "post").then(res => {
                if(res.data.code == 200){
                    var n = 60;
                    this.btnTxt = '重新发送' + n +'s';
                    let timer = window.setInterval(() => {   
                        n--;                     
                        this.btnTxt = '重新发送' + n +'s';
                        if(n < 1){
                            window.clearInterval(timer);
                            this.btnTxt = '获取验证码';
                        }
                    },1000)
                    Toast.success("发送成功");
                }else{
                    Dialog.alert({title: "提示", message:res.data.message});
                }
            })
        },
        cancelSelectAddress() {
            this.dataFrom.pcaAddress = "";
            this.dataFrom.addressVisible = false;
        },
        showAddressVisible() {
            this.dataFrom.addressVisible = true;
        },
        selectAddress(values) {
            if (!values[0].code || values[0].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[1].code || values[1].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (!values[2].code || values[2].code.length < 1) {
                Toast.fail("请选择地区");
                return;
            }

            if (
                values[0].code == "110000" ||
                values[0].code == "120000" ||
                values[0].code == "310000" ||
                values[0].code == "500000"
            ) {
                this.dataFrom.pcaAddress = values[0].name + values[2].name;
            } else {
                this.dataFrom.pcaAddress = values[0].name + values[1].name + values[2].name;
            }
            this.dataFrom.addressVisible = false;
        },
        sunmbitFn(){
            this.dataFrom.smsCode=this.smsCode;
            this.$refs.form.validate().then(() => {     
                wxRequest('applyChangeSim/apply/sim/my', this.dataFrom, 'post').then(res => {
                    if(res.data.code == 200){
                        Toast.success(res.data.message);
                        this.dataFrom={
                            takeNickname:'' ,
                            addressVisible:false,
                            takePhone:'',
                            smsCode:'',
                            takeAddress:'',
                            changeCmccSim:2,
                            pcaAddress:'',
                        }
                    }else {
                        Toast.fail(res.data.message);
                    }
                })
            })
        },
    }
};
</script>
<style scoped lang="less">
.recommendPage {
    .swiper-container{
        position: relative;
        width: 100%;
        height:313px;
        margin:12px 0;
    }  
    .swiper-container .swiper-slide{
        width: 100%;
        line-height: 313px;
        color: #000;
        font-size: 16px;
        text-align: center;
    }
    .shrxx{
        margin-left:14px;
        font-size: 14px;
        color:#000;
        margin-bottom:11px;
    }
    .van-cell-group{
        margin-bottom:24px;
        margin-left:14px;
        margin-right:14px;
        .van-cell{
            background: #FAFAFA;
            border-radius: 22px;
            color:#000;
        }
        &::after{
            border:none;
        }
    }
    .codeBtn{
        background: #FF680C;
        height:44px;
        line-height:44px;
        border-radius:22px;
        border:1px solid #FF680C;
        width:90%;
        margin-left:8px;
    }
    .btnButton{
        background: #FF680C;
        height:44px;
        line-height:44px;
        border-radius:22px;
        border:1px solid #FF680C;
        width:90%;
        margin:10px auto 10px auto; 
    }
}
</style>